import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as Service from "../services";
import makeData from "../services/makeData";
import { GENERAL } from "../config/Transaction/ProductGeneralConf";

import { COLUMNS } from "../config/Transaction/columns";
import { addAfterLoginNotification } from "../../../components/Toast/utils/notifications";

interface AsyncState {
  isLoading: {
    adminData: boolean;
    adminDelete: boolean;
    // offerAdd: boolean;
    // deleteOffer: boolean;
  };
  isSuccess: boolean;
  isError: boolean;
}

interface TableState extends AsyncState {
  adminData: any;
  totalCount: Number;
  statusData: any;
  applicationOptions: any;
  addOfferRes: any;
  editProductRes: any;
  deleteAdminRes: any;
  isLogout: any;
  fullResponse: Array<any>;
  brandsData: Array<any>;
  rootReducer?: any;
  auth?: any;
  errorMsg?: any;
  userTableColumns: any;
}

const initialState: TableState = {
  isLoading: {
    adminData: true,
    adminDelete: true,
    // offerAdd: false,
    // deleteOffer: false,
  },
  isSuccess: false,
  isError: false,
  adminData: null,
  statusData: null,
  applicationOptions: null,
  addOfferRes: {},
  editProductRes: null,
  deleteAdminRes: null,
  totalCount: NaN,
  isLogout: false,
  fullResponse: [],
  brandsData: [],
  errorMsg: null,
  userTableColumns: COLUMNS,
};

export const fetchAllAdmins = createAsyncThunk("admin", async (_, thunkAPI) => {
  try {
    const res: any = await Service.getAllAdmin();

    const madeData = makeData(res.data);

    return { madeData, totalCount: res.totalCounts, fullResponse: res.data };
  } catch (error: any) {
    // thunkAPI.dispatch(resetLogout(error))
    return thunkAPI.rejectWithValue(error);
  }
});

// export const addOffer = createAsyncThunk('user/addBrandData', async (data: any, thunkAPI) => {
//   try {
//     return await Service.addOffer(data);
//   } catch (error) {
//     // thunkAPI.dispatch(resetLogout(error));
//     return thunkAPI.rejectWithValue(error);
//   }
// });

export const deleteAdmin = createAsyncThunk(
  "admin/delete",
  async (data: any, thunkAPI) => {
    try {
      return await Service.deleteAdmin(data);
    } catch (error) {
      // thunkAPI.dispatch(resetLogout(error));
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getColumns = createAsyncThunk(
  "getColumns",
  (data: any, thunkAPI) => {
    try {
      // const madeColsData = makeData(data);
      return data?.cols;
    } catch (error) {
      // thunkAPI.dispatch(resetLogout(error));
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const offerSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    resetAddOfferRes: (state) => {
      state.addOfferRes = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //Obtaining data
      .addCase(fetchAllAdmins.pending, (state, action: any) => {
        state.isLoading.adminData = true;
        state.isError = false;
        state.errorMsg = null;
      })
      .addCase(fetchAllAdmins.fulfilled, (state, action: any) => {
        state.isLoading.adminData = false;
        state.isSuccess = true;
        state.isError = false;
        state.adminData = action.payload.madeData;
        state.totalCount = action.payload.totalCount;
        state.fullResponse = action.payload.fullResponse;
        state.errorMsg = null;
      })
      .addCase(fetchAllAdmins.rejected, (state, action: any) => {
        state.isLoading.adminData = false;
        state.isError = true;
        state.errorMsg = action.payload.errorMsg;
        state = {
          ...state,
          ...action.payload,
        };
      })

      //delete admin
      .addCase(deleteAdmin.pending, (state, action: any) => {
        state.isLoading.adminDelete = true;
        state.isError = false;
        state.errorMsg = null;
      })
      .addCase(deleteAdmin.fulfilled, (state, action: any) => {
        addAfterLoginNotification(action?.payload?.message, "success");
        state.isLoading.adminDelete = false;
        state.isError = false;
        state.errorMsg = null;
        state.isSuccess = true;
        state.deleteAdminRes = action?.payload;
      })
      .addCase(deleteAdmin.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.adminDelete = false;
        state.isError = true;
        state.isSuccess = false;
        state.errorMsg = action.payload.errorMsg;
      })

      // MODIFY_COLUMNS
      .addCase(getColumns.pending, (state) => {
        // state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.userTableColumns = initialState.userTableColumns;
      })
      .addCase(getColumns.fulfilled, (state, action: any) => {
        // state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.userTableColumns = action.payload;
      })
      .addCase(getColumns.rejected, (state) => {
        // state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.userTableColumns = initialState.userTableColumns;
      });
  },
});
export const { resetAddOfferRes } = offerSlice.actions;
export default offerSlice.reducer;
